import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Typography } from '@tempmee/react';
import { OutlineChevronRightIcon } from '@tempmee/react-icons';
import { PROMO_CODES_PATH } from '../paths';

/**
 * The Promo Codes trail on the detail page: Promo Codes › **code name**.
 *
 * Same shape as BestInDentalBreadcrumbs, for the same reasons: the ancestor
 * is a react-router `Link` so the design system styles it via `[&_a]` without
 * a bare `<a>`, and the link stays when the code failed to load because it is
 * the way out.
 */
const CurrentCrumb = ({ children }) => (
  <Typography as="span" variant="body1" aria-current="page" className="text-text-secondary">
    {children}
  </Typography>
);

CurrentCrumb.propTypes = { children: PropTypes.node.isRequired };

export const PromoCodeBreadcrumbs = ({ codeName }) => (
  <Breadcrumbs separator={<OutlineChevronRightIcon aria-hidden className="size-4" />}>
    <RouterLink to={PROMO_CODES_PATH}>Promo Codes</RouterLink>
    {codeName ? <CurrentCrumb>{codeName}</CurrentCrumb> : null}
  </Breadcrumbs>
);

PromoCodeBreadcrumbs.propTypes = {
  /** The code's name. Omitted when it fails to load. */
  codeName: PropTypes.string,
};

PromoCodeBreadcrumbs.defaultProps = { codeName: undefined };

export default PromoCodeBreadcrumbs;
